const HTML_ATTRIBUTE_WITH_DOUBLE_QUOTES = / [a-zA-Z].+?="(.*?)"/g;
const HTML_ATTRIBUTE_WITH_SINGLE_QUOTES = / [a-zA-Z].+?='(.*?)'/g;
function _replaceMatchedAttribute(match, capture) {
  return match.replace(capture, decodeAttributes(capture));
}
function encodeAttributes(uri) {
  let regex = new RegExp('{{[^}]+}}', 'g');
  if (!uri) {
    return '';
  }
  return uri.replace(regex, function (match) {
    let encoded = window.encodeURIComponent(match);
    // TODO: POB: Unsure if this is required but it matches existing behaviour
    // POC: `encodeURIComponent` does not encode single quotes as they are valid URL characters. But this causes problems as the URL later gets HTML encoded resulting in single quotes being stored as &#x27;
    return encoded.replace('fallback%3A', 'fallback:').replace(/'/g, '%27');
  });
}
function decodeAttributes(uri) {
  let regex = /%7B%7B.+%7D%7D/g;
  let match;
  while (match = regex.exec(uri)) {
    try {
      uri = uri.replace(match[0], window.decodeURIComponent(match[0]));
    } catch (e) {
      console.log('received an invalid URI component ', match[0]);
    }
  }
  return uri;
}
function encodeUriAttributes(html) {
  return html.replace(/<([^>]*)>/g, function (match, capture) {
    return match.replace(capture, encodeAttributes(capture));
  });
}
function decodeUriAttributes(html) {
  return html.replace(HTML_ATTRIBUTE_WITH_DOUBLE_QUOTES, _replaceMatchedAttribute).replace(HTML_ATTRIBUTE_WITH_SINGLE_QUOTES, _replaceMatchedAttribute);
}
export { encodeAttributes, decodeAttributes, encodeUriAttributes, decodeUriAttributes };